<template>
  <div class="reports">
    <div class="reports-listing">
      <div class="filter-wrapper">
        <div class="inputs-wrapper">
          <h3>Tip:</h3>
          <md-field>
            <label>Tip</label>
            <md-select v-model="kind">
              <md-option v-for="kind, key in $store.state.ansemble" :value="key">
                {{ kind }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="inputs-wrapper">
          <h3>Period u mjesecima:</h3>
          <md-radio v-model="period" :value="1">1</md-radio>
          <md-radio v-model="period" :value="3">3</md-radio>
          <md-radio v-model="period" :value="6">6</md-radio>
          <md-radio v-model="period" :value="12">12</md-radio>
        </div>
        <div class="inputs-wrapper">
          <h3>Period ({{ monthTitle }}):</h3>
          <md-field v-if="period == 1">
            <label>{{ monthTitle }}</label>
            <md-select v-model="month">
              <md-option v-for="i in Array.from({length: 12}, (x,i) => i+1)" :value="i">
                {{ i }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-else-if="period == 3">
            <label>{{ monthTitle }}</label>
            <md-select v-model="month">
              <md-option v-for="i in Array.from({length: 4}, (x,i) => i+1)" :value="i">
                {{ i }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-else-if="period == 6">
            <label>{{ monthTitle }}</label>
            <md-select v-model="month">
              <md-option v-for="i in Array.from({length: 2}, (x,i) => i+1)" :value="i">
                {{ i }}
              </md-option>
            </md-select>
          </md-field>
          <md-field v-else-if="period == 12">
            <label>{{ monthTitle }}</label>
            <md-select v-model="month">
              <md-option v-for="i in Array.from({length: 1}, (x,i) => i+1)" :value="i">
                {{ i }}
              </md-option>
            </md-select>
          </md-field>
        </div>
        <div class="inputs-wrapper">
          <h3>Godina:</h3>
          <md-field>
            <label>Godina</label>
            <md-select v-model="year">
              <md-option value="2018">2018</md-option>
              <md-option value="2019">2019</md-option>
              <md-option value="2020">2020</md-option>
              <md-option value="2021">2021</md-option>
	            <md-option value="2022">2022</md-option>
              <md-option value="2023">2023</md-option>
              <md-option value="2024">2024</md-option>
              <md-option value="2025">2025</md-option>
            </md-select>
          </md-field>
        </div>
        <div class="inputs-wrapper with-button">
          <md-button class="md-raised md-dense md-primary" v-on:click="showReport()">Prikaži</md-button>
        </div>
      </div>
      <div v-if="$store.state.pageLoaded">
      <div v-if="$store.state.receivedData.reportsPerformanceGeneral.list && Object.keys($store.state.receivedData.reportsPerformanceGeneral.list.play).length > 0" ref="reports" class="reports">
      <md-button class="md-primary md-dense md-raised fixed-print-btn print-btn" v-on:click="print($refs.reports)">
        Ispiši
      </md-button>
      <md-button class="md-accent md-dense md-raised fixed-print-btn print-btn download-report" @click="getXLSX()">
        Preuzmi
      </md-button>
       <h2 class="md-title">
        Kumulativni izvještaj detaljno - {{ $store.state.ansemble[kind] }}
        <span class="lighter">
          {{ new Date($store.state.receivedData.reportsPerformanceGeneral.list.filter_start_time).toLocaleDateString('hr-HR') }}
          -
          {{ new Date($store.state.receivedData.reportsPerformanceGeneral.list.filter_end_time).toLocaleDateString('hr-HR') }}
        </span>
      </h2>
      <md-table class="print-table general-table">
        <md-table-row>
          <md-table-head>Datum i vrijeme</md-table-head>
          <md-table-head>Blagajna</md-table-head>
          <md-table-head>Gratis</md-table-head>
          <md-table-head>Gratis Škole</md-table-head>
          <md-table-head>Zamjena Web</md-table-head>
          <md-table-head>Zamjena Pretplata</md-table-head>
          <md-table-head>Protokol</md-table-head>
          <md-table-head>Premijera</md-table-head>
          <md-table-head>Najam</md-table-head>
          <md-table-head>PRESS</md-table-head>
          <md-table-head>Web</md-table-head>
          <md-table-head>Zakup</md-table-head>
          <md-table-head>Sponzor</md-table-head>
          <md-table-head>Pretplata</md-table-head>
          <md-table-head>Ukupno</md-table-head>
          <md-table-head>U prodaji</md-table-head>
          <md-table-head>Prodaja</md-table-head>
          <md-table-head>Pretplata</md-table-head>
          <md-table-head>Zakupi</md-table-head>
          <md-table-head>Sponzori</md-table-head>
          <md-table-head>Ukupno</md-table-head>
        </md-table-row>
      </md-table>
      <md-table v-for="play in $store.state.receivedData.reportsPerformanceGeneral.list.play" class="print-table general-table">
        <md-table-row v-for="performance in play.performances">
          <md-table-cell>{{ play.title }} {{ new Date(performance.start_time).toLocaleDateString('hr-HR') }}</md-table-cell>
          <md-table-cell>{{ performance.count.offline_sold }}</md-table-cell>
          <md-table-cell>{{ performance.count.free }}</md-table-cell>
          <md-table-cell>{{ performance.count.free_schools }}</md-table-cell>
          <md-table-cell>{{ performance.count.swap_web }}</md-table-cell>
          <md-table-cell>{{ performance.count.swap_sub }}</md-table-cell>
          <md-table-cell>{{ performance.count.protocol }}</md-table-cell>
          <md-table-cell>{{ performance.count.premiere }}</md-table-cell>
          <md-table-cell>{{ performance.count.najam }}</md-table-cell>
          <md-table-cell>{{ performance.count.press }}</md-table-cell>
          <md-table-cell>{{ performance.count.online_sold }}</md-table-cell>
          <md-table-cell>{{ performance.count.lease }}</md-table-cell>
          <md-table-cell>{{ performance.count.sponsor }}</md-table-cell>
          <md-table-cell>{{ performance.count.subscription }}</md-table-cell>
          <md-table-cell>{{ performance.count.all }}</md-table-cell>
          <md-table-cell>{{ performance.count.for_sale }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(performance.amount.sold) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(performance.amount.subscription) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(performance.amount.lease) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(performance.amount.sponsor) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(performance.amount.all) }}</md-table-cell>
        </md-table-row>
        <md-table-row class="last-row">
          <md-table-cell><strong>{{ play.title}} - broj izvedbi: {{ Object.keys(play.performances).length }}</strong></md-table-cell>
          <md-table-cell>{{ play.count.offline_sold }}</md-table-cell>
          <md-table-cell>{{ play.count.free }}</md-table-cell>
          <md-table-cell>{{ play.count.free_schools }}</md-table-cell>
          <md-table-cell>{{ play.count.swap_web }}</md-table-cell>
          <md-table-cell>{{ play.count.swap_sub }}</md-table-cell>
          <md-table-cell>{{ play.count.protocol }}</md-table-cell>
          <md-table-cell>{{ play.count.premiere }}</md-table-cell>
          <md-table-cell>{{ play.count.najam }}</md-table-cell>
          <md-table-cell>{{ play.count.press }}</md-table-cell>
          <md-table-cell>{{ play.count.online_sold }}</md-table-cell>
          <md-table-cell>{{ play.count.lease }}</md-table-cell>
          <md-table-cell>{{ play.count.sponsor }}</md-table-cell>
          <md-table-cell>{{ play.count.subscription }}</md-table-cell>
          <md-table-cell>{{ play.count.all }}</md-table-cell>
          <md-table-cell>{{ play.count.for_sale }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(play.amount.sold) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(play.amount.subscription) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(play.amount.lease) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(play.amount.sponsor) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency(play.amount.all) }}</md-table-cell>
        </md-table-row>
      </md-table>
      <md-table class="print-table general-table">
        <md-table-row class="last-row">
          <md-table-cell><strong>Sveukupno</strong></md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.offline_sold }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.free }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.free_schools }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.swap_web }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.swap_sub }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.protocol }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.premiere }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.najam }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.press }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.online_sold }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.lease }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.sponsor }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.subscription }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.all }}</md-table-cell>
          <md-table-cell>{{ $store.state.receivedData.reportsPerformanceGeneral.list.general.count.for_sale }}</md-table-cell>
          <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsPerformanceGeneral.list.general.amount.sold) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsPerformanceGeneral.list.general.amount.subscription) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsPerformanceGeneral.list.general.amount.lease) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsPerformanceGeneral.list.general.amount.sponsor) }}</md-table-cell>
          <md-table-cell>{{ formatCurrency($store.state.receivedData.reportsPerformanceGeneral.list.general.amount.all) }}</md-table-cell>
        </md-table-row>
      </md-table>
      </div>

    </div>
  </div>
  </div>
</template>

<script>
import FormatCurrency from '../../../mixins/format-currency';
import ReportsMixin from '../../../mixins/reports-mixin';
export default {
  name: 'ReportsPerformanceGeneral',
  mixins: [FormatCurrency, ReportsMixin('')],
  data(){
    return{
      period: 1,
      year: new Date().getFullYear(),
      month: new Date().getMonth()+1,
      kind: 0,
    }
  },

  computed:{
    monthTitle(){
      switch(this.period){
        case 1:
        return 'Mjesec';
        break;
        case 3:
        return 'Tromjesečje';
        break;
        case 6:
        return 'Polugodište'
        break;
        case 12:
        return 'Godina'
        break;
      }
    }
  },

  mounted(){
    this.$store.state.ansemble[0] = "Svi";
  },

  methods:{
    async showReport(){
      this.$store.state.pageLoaded = false;
      let filter = {
        kind: this.kind,
        periodKind: this.period,
        period: this.month,
        year: this.year
      }
      await this.$store.dispatch('getReportsPerformanceGeneral', filter)
      if(this.kind == "0") this.$store.state.ansemble[this.kind] = "Svi";
      this.$store.state.pageLoaded = true;
    },
    async getXLSX() {
      await this.$store.dispatch('getExportWithParams', {'list': 'reportsPerformanceGeneral','params': `&kind=${this.kind}&period_kind=${this.period}&period=${this.month}&year=${this.year}`})
    }
  },

  watch:{
    period(){
      this.month = 1;
    }
  }
}
</script>

<style lang="scss" scoped>
  .reports{
    padding-bottom: 80px;
  }
  .reports h2{
    text-align: center;
    margin: 50px 0;
    span{
      display: block;
    }

    .lighter{
      margin-top: 15px;
      font-size: 16px;
    }
  }

  .filter-wrapper{
    display: flex;
    margin-bottom: 50px;
    .inputs-wrapper{
      min-width: auto;
      & + .inputs-wrapper{
        margin-left: 50px;
      }
    }
  }

  .error{
    font-size: 22px;
    margin: 50px 0;
    text-align: center;
    color: rgba(0, 0, 0, 0.87);
    font-weight: 400;
  }

  .with-button{
    align-self: flex-end;
    margin-bottom: 20px;
  }

  .md-table{
    &:not(:first-of-type){
      & + .md-table{
        margin-top: 50px;
      }
    }
  }

  table{
    text-align: left;
    td, th{
      &:first-of-type{
        width: 200px;
        max-width: 200px;
        min-width: 200px;
      }
      &:not(:first-of-type){
        width: 100px;
        min-width: 100px;
        max-width: 100px;
      }
    }
  }

  .download-report{
    margin-right: 110px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Tickets/ReportsPerformanceGeneral.vue